import ScreenwrapperModule from './containers/screenwrapperModule'

export {default as ScreenwrapperModuleLayout} from './components/screenwrapperModuleLayout'

export default ScreenwrapperModule
